import { c as _c } from "react/compiler-runtime";
import { GOTHAM } from '@cc-shopping/ui/theme';
import { Box, Typography } from '@mui/material';
import { Rating } from 'src/features/product-card/NerdWalletRating/Rating';
import { StarRatingTooltip } from 'src/features/product-card/NerdWalletRating/StarRatingTooltip';
import { useReviewContext } from '../../../Context';
export default function ReviewProductCardRating() {
  const $ = _c(21);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    starRating,
    details: t1
  } = t0;
  const {
    isMonetizing
  } = t1;
  if (!starRating) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      flexWrap: "wrap"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "row"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontSize: "2rem",
      fontWeight: "500",
      fontFamily: GOTHAM,
      pr: {
        xs: 2,
        md: 1
      },
      alignSelf: {
        xs: "center",
        md: "flex-start"
      },
      lineHeight: 1,
      mt: 0.25
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== starRating) {
    t5 = starRating.toFixed(1);
    $[3] = starRating;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <Typography sx={t4}>{t5}</Typography>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      marginTop: "2px"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== starRating) {
    t8 = <Rating value={starRating} additionalStyles={t7} size="21.5px" gap="7px" />;
    $[8] = starRating;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <Box sx={t3}>{t6}{t8}</Box>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      display: "flex",
      gap: 1
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      display: "flex",
      alignItems: "center",
      whiteSpace: "nowrap",
      flexDirection: "row",
      justifyContent: "center"
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Box sx={t11}><Typography variant="textSmall" sx={{
        fontSize: "0.8rem",
        fontStyle: "normal",
        fontFamily: GOTHAM,
        letterSpacing: 0.5,
        mb: 0.5,
        color: "neutral.darker",
        textTransform: "uppercase"
      }}>NerdWallet rating</Typography></Box>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== isMonetizing) {
    t13 = <Box sx={t10}>{t12}<Box><StarRatingTooltip maxWidth="17.25rem" segmentActionSection="marketplace_comparison_table_product" isMonetizing={isMonetizing} /></Box></Box>;
    $[16] = isMonetizing;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13 || $[19] !== t9) {
    t14 = <Box sx={t2}>{t9}{t13}</Box>;
    $[18] = t13;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  return t14;
}